import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Signal, signal, WritableSignal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { moods } from '@app/_datas/const.data';
import { SvgComponent } from '../../svg/svg.component';
import { MapService } from '@app/_services/map.service';
import { SettingsService } from '@app/_services/settings.service';
import { InputCheckboxComponent } from '../../inputs/input-checkbox/input-checkbox.component';
import { AnalyticsService } from '@app/_services/analytics.service';

@Component({
    selector: 'app-filter-mood',
    imports: [
        CommonModule,
        MatMenuModule,
        SvgComponent,
        InputCheckboxComponent
    ],
    templateUrl: './filter-mood.component.html',
    styleUrl: './filter-mood.component.scss'
})

export class FilterMoodComponent implements OnInit {

  @Input() signal: WritableSignal<number[]> = signal<number[]>([]);
  @Input() multiple: boolean = false;
  moods: number[] = moods.sort((a, b) => b - a);
  moodMap: Signal<Record<number, string>> = this.mapService.moodMap;
  moodEmojiMap: Signal<Record<number, string>> = this.mapService.moodEmojiMap;

  @Output() select = new EventEmitter<string>();

  // Local optimistic state — updates instantly on click, independent of store propagation
  selectedItems = signal<number[]>([]);

  constructor(private sanitizer: DomSanitizer, public ss: SettingsService, private mapService: MapService, private as: AnalyticsService) {

  }

  ngOnInit(): void {
    this.selectedItems.set(this.signal());
  }

  getLabel() {
    // {{signal().length ? signal().length === 1 ? moodMap()[signal()[0]] : signal().length + ' ' + 'Moods' : 'Mood' }}
    if (this.selectedItems().length === 0) {
      return this.ss.t('common_mood');
    } else if (this.selectedItems().length === 1) {
      return this.moodMap()[this.selectedItems()[0]];
    } else {
      return this.ss.t('common_filterMoodMultiple', { numberOfMoods: this.selectedItems().length.toString() });
    }
  }

  getSanitizedSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  onMoodSelected(mood: number, event: MouseEvent): void {
    this.as.filterEvent('mood', this.moodMap()[mood]);
    if (this.multiple) {
      const current = this.selectedItems();
      const updated = current.includes(mood)
        ? current.filter((m) => m !== mood)
        : [...current, mood];
      // Update local state immediately (optimistic)
      this.selectedItems.set(updated);
      // Update store — triggers data reload in background
      this.signal.set(updated);
      this.select.emit();
      event.stopPropagation();
    } else {
      this.selectedItems.set([mood]);
      this.signal.set([mood]);
      this.select.emit();
    }
  }
}
